module.exports = __webpack_public_path__ + "static/media/hidden.b437e3fc.svg";